import { apiClient } from 'shared/lib/apiClient';
import type {
  CourierDocument,
  VehicleType,
  YearsOfExperienceRange,
} from 'features/courier-onboarding/types';

export interface CourierStatus {
  submissionId: string;
  status: { statusId: number; statusTitle: string } | null;
  createdAt: string;
  updatedAt: string;
}

export interface CourierSubmissionView {
  submissionId: string;
  fullName: string;
  phoneNumber: string;
  email: string;
  taxId: string;
  dateOfBirth: string;
  city: string;
  spokenLanguages: string[];
  vehicleType: VehicleType;
  vehicleTypes?: VehicleType[];
  hasDeliveryExperience: boolean;
  yearsOfExperienceRange: YearsOfExperienceRange | null;
  documents: CourierDocument[];
  notes: string | null;
  status: { statusId: number; statusTitle: string } | null;
  createdAt: string;
  updatedAt: string;
}

export const fetchStatus = async (): Promise<CourierStatus> => {
  const { data } = await apiClient.get<CourierStatus>('/api/courier/me/status');
  return data;
};

export type RecruitmentStage =
  | 'DOCUMENTS'
  | 'TRAINING'
  | 'CONTRACT'
  | 'EQUIPMENT'
  | 'APPROVED'
  | 'STUCK'
  | 'INCOMPLETE_PROCESS'
  | 'DISQUALIFIED';

/** Happy-path stages rendered in the stepper, in order. */
export const RECRUITMENT_STAGE_ORDER: RecruitmentStage[] = [
  'DOCUMENTS',
  'TRAINING',
  'CONTRACT',
  'EQUIPMENT',
  'APPROVED',
];

export interface CourierMondayStatus {
  stage: RecruitmentStage;
  stageOrder: number;
  totalStages: number;
  isTerminal: boolean;
  isFailure: boolean;
  failReason: string | null;
  rawStatus: string | null;
  rawGroup: string | null;
  boardName: string | null;
  mondayItemId: string | null;
  fetchedAt: string;
}

export const fetchMondayStatus = async (): Promise<CourierMondayStatus> => {
  const { data } = await apiClient.get<CourierMondayStatus>(
    '/api/courier/me/monday-status',
  );
  return data;
};

export const fetchSubmission = async (): Promise<CourierSubmissionView> => {
  const { data } = await apiClient.get<CourierSubmissionView>(
    '/api/courier/me/submission',
  );
  return data;
};
